import { Injectable } from '@angular/core';
/* import { Http, RequestOptionsArgs, Response } from '@angular/common/http'; */
import { Observable, map, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Globals } from '../../globals/globals';
import { oDataRes } from '../../models/data/oData.model';
import { ActiveFilter, GridSorting, ODataGridFilter } from '../../teiasoft-bucket/teiasoft-grid-odata/teiasoft-grid-odata.component';
import { withAssetVersion } from '../../utils/asset-version';
import { getDateOnlyRangeEndExclusive, getDateOnlyRangeStart } from '../../utils/date-only.utils';
/* import { parseString } from 'xml2js';
 */
export enum RequestTypes {
  get,
  post,
  put,
  delete,
  patch,
  head,
  options
}

export interface IUrlOptions {
  restOfUrl: string,
}

@Injectable({
  providedIn: 'root'
})

export class TeiasoftOdataService {
  constructor(private httpClient: HttpClient, private globals: Globals) {
  }

  /***:
   * GET THE oData entity metadata
   */
  discoverServiceMetadata(entityName: string): Observable<any> {
    const metadataUrl = `${this.globals.apiUrl}odata/$metadata?$format=json`;
    return this.httpClient.get(metadataUrl, { responseType: 'text' });
  }

  callOData(entity: string, filters: ActiveFilter[], gridSorting: GridSorting[], defaultView: string, top?: number, skip?: number, defaultFilters?: string): Observable<oDataRes> {
    if (entity == 'Enquiries') {
      if (this.globals.isMock) {
        return this.httpClient.get<oDataRes>(withAssetVersion('assets/mock/enquiryBooks.json'));
      } else {
        let _filters: string = "";
        if (filters && filters.length > 0) _filters = this.filterBuilder(filters);
        let _orderBy: string = "";
        if (gridSorting && gridSorting.length > 0) _orderBy = this.orderByBuilder(gridSorting);
        if (_orderBy == '') _orderBy = '$orderby=CreationDate desc'; //'$orderby=LastRevisionDate desc'; 
        let _oDataParams: string = (_filters != '' ? _filters + "&" : '') + _orderBy;

        // Include top and skip parameters if provided
        if (top !== undefined && skip !== undefined) {
          _oDataParams += `&$top=${top}&$skip=${skip}`;
        }

        if (_filters != '' || _orderBy != '') _oDataParams = '?' + _oDataParams;

        //console.log("[QuoteTool] oDataService oData query parameters: " + _oDataParams);
        return this.httpClient.get<oDataRes>(`${this.globals.apiUrl}odata/Enquiries/${defaultView}${_oDataParams}`);
      }
    }

    if (entity == 'Logs') {
      let _filters: string = "";
      if (filters && filters.length > 0) _filters = this.filterBuilder(filters);
      let _orderBy: string = "";
      if (gridSorting && gridSorting.length > 0) _orderBy = this.orderByBuilder(gridSorting);
      if (_orderBy == '') _orderBy = '$orderby=LogTimestamp desc';
      if (_orderBy.indexOf("LogTimestamp desc") != -1) _orderBy = _orderBy + ',Id desc';
      if (_orderBy.indexOf("LogTimestamp asc") != -1) _orderBy = _orderBy + ',Id asc';
      let _oDataParams: string = (_filters != '' ? _filters + "&" : '') + _orderBy;

      if (top !== undefined && skip !== undefined) {
        _oDataParams += `&$top=${top}&$skip=${skip}`;
      }
      if (_filters != '' || _orderBy != '') _oDataParams = '?' + _oDataParams;
      //console.log("[QuoteTool] oDataService oData query parameters: " + _oDataParams);
      return this.httpClient.get<oDataRes>(`${this.globals.apiUrl}odata/logs/getLogs/${defaultView}${_oDataParams}`);
    }

    if (entity == 'History') {
      let _filters: string = "";
      if (filters && filters.length > 0) _filters = this.filterBuilder(filters);
      let _orderBy: string = "";
      if (gridSorting && gridSorting.length > 0) _orderBy = this.orderByBuilder(gridSorting);
      if (_orderBy == '') _orderBy = '$orderby=LastRevisionDate desc';
      let _oDataParams: string = (_filters != '' ? _filters + "&" : '') + _orderBy;

      if (top !== undefined && skip !== undefined) {
        _oDataParams += `&$top=${top}&$skip=${skip}`;
      }

      if (_filters != '' || _orderBy != '') _oDataParams = '?' + _oDataParams;

      //console.log("[QuoteTool] oDataService oData query parameters: " + _oDataParams);
      return this.httpClient.get<oDataRes>(`${this.globals.apiUrl}odata/history/getHistory/${defaultView}${_oDataParams}`);
    }

    if (entity == 'getNormGrades') {
      let _filters: string = "";
      if (filters && filters.length > 0) _filters = this.filterBuilder(filters);
      let _orderBy: string = "";
      if (gridSorting && gridSorting.length > 0) _orderBy = this.orderByBuilder(gridSorting);
      if (_orderBy == '') _orderBy = '$orderby=NormGradeCode asc';
      let _oDataParams: string = (_filters != '' ? _filters + "&" : '') + _orderBy;

      if (top !== undefined && skip !== undefined) {
        _oDataParams += `&$top=${top}&$skip=${skip}`;
      }

      if (_filters != '' || _orderBy != '') _oDataParams = '?' + _oDataParams;

      console.log("[QuoteTool] oDataService oData defaultView: " + defaultView);
      console.log("[QuoteTool] oDataService oData query parameters: " + _oDataParams);
      return this.httpClient.get<oDataRes>(`${this.globals.apiUrl}odata/normGrades/getNormGrades/${defaultView}${_oDataParams}`);
    }

    if (entity == 'getRawMaterialGrades') {
      let _filters: string = "";
      if (filters && filters.length > 0) _filters = this.filterBuilder(filters);
      let _orderBy: string = "";
      if (gridSorting && gridSorting.length > 0) _orderBy = this.orderByBuilder(gridSorting);
      if (_orderBy == '') _orderBy = '$orderby=rawMaterialGradeCode asc';
      let _oDataParams: string = (_filters != '' ? _filters + "&" : '') + _orderBy;

      if (top !== undefined && skip !== undefined) {
        _oDataParams += `&$top=${top}&$skip=${skip}`;
      }

      if (_filters != '' || _orderBy != '') _oDataParams = '?' + _oDataParams;

      console.log("[QuoteTool] oDataService oData defaultView: " + defaultView);
      console.log("[QuoteTool] oDataService oData query parameters: " + _oDataParams);
      return this.httpClient.get<oDataRes>(`${this.globals.apiUrl}odata/rawMaterialGrades/getRawMaterialGrades/${defaultView}${_oDataParams}`);
    }

    if (entity == 'getCustomersWithBonusAgreement') {
      let _filters: string = "";
      if (filters && filters.length > 0) _filters = this.filterBuilder(filters);
      let _orderBy: string = "";
      if (gridSorting && gridSorting.length > 0) _orderBy = this.orderByBuilder(gridSorting);
      if (_orderBy == '') _orderBy = '$orderby=customerName asc';
      let _oDataParams: string = (_filters != '' ? _filters + "&" : '') + _orderBy;

      if (top !== undefined && skip !== undefined) {
        _oDataParams += `&$top=${top}&$skip=${skip}`;
      }

      if (_filters != '' || _orderBy != '') _oDataParams = '?' + _oDataParams;

      console.log("[QuoteTool] oDataService oData defaultView: " + defaultView);
      console.log("[QuoteTool] oDataService oData query parameters: " + _oDataParams);
      return this.httpClient.get<oDataRes>(`${this.globals.apiUrl}odata/customersWithBonusAgreement/getCustomersWithBonusAgreement/${defaultView}${_oDataParams}`);
    }

    if (entity == 'getSms') {
      let _filters: string = "";
      if (filters && filters.length > 0) _filters = this.filterBuilder(filters);
      let _orderBy: string = "";
      if (gridSorting && gridSorting.length > 0) _orderBy = this.orderByBuilder(gridSorting);
      if (_orderBy == '') _orderBy = '$orderby=sms asc';
      let _oDataParams: string = (_filters != '' ? _filters + "&" : '') + _orderBy;

      if (top !== undefined && skip !== undefined) {
        _oDataParams += `&$top=${top}&$skip=${skip}`;
      }

      if (_filters != '' || _orderBy != '') _oDataParams = '?' + _oDataParams;

      console.log("[QuoteTool] oDataService oData defaultView: " + defaultView);
      console.log("[QuoteTool] oDataService oData query parameters: " + _oDataParams);
      return this.httpClient.get<oDataRes>(`${this.globals.apiUrl}odata/sms/getSms/${defaultView}${_oDataParams}`);
    }

    if (entity == 'SimilarEnquiries') {
      let _filters: string = "";
      if (filters && filters.length > 0) _filters = this.filterBuilder(filters);
      let _orderBy: string = "";
      if (gridSorting && gridSorting.length > 0) _orderBy = this.orderByBuilder(gridSorting);
      if (_orderBy == '') _orderBy = '$orderby=CreationDate desc'; //'$orderby=LastRevisionDate desc'; 
      let _oDataParams: string = (_filters != '' ? _filters + "&" : '') + _orderBy;

      // Include top and skip parameters if provided
      if (top !== undefined && skip !== undefined) {
        _oDataParams += `&$top=${top}&$skip=${skip}`;
      }

      if (_filters != '' || _orderBy != '') _oDataParams = '?' + _oDataParams;

      if (defaultFilters) _oDataParams += ('&' + defaultFilters);

      return this.httpClient.get<oDataRes>(`${this.globals.apiUrl}odata/Enquiries/getAll/${_oDataParams}`);
    }

    if (entity == 'activeItdcrs' || entity == 'toComeItdcrs' || entity == 'latestSentItdcrs') {
      let _filters: string = "";
      if (filters && filters.length > 0) _filters = this.filterBuilder(filters);
      let _orderBy: string = "";
      if (gridSorting && gridSorting.length > 0) _orderBy = this.orderByBuilder(gridSorting);
      if (_orderBy == '') _orderBy = '$orderby=Id desc';
      let _oDataParams: string = (_filters != '' ? _filters + "&" : '') + _orderBy;

      if (top !== undefined && skip !== undefined) {
        _oDataParams += `&$top=${top}&$skip=${skip}`;
      }

      if (_filters != '' || _orderBy != '') _oDataParams = '?' + _oDataParams;

      return this.httpClient.get<oDataRes>(`${this.globals.apiUrl}odata/${entity}/${defaultView}${_oDataParams}`);
    }

    if (entity == 'itdcrsHistory') {
      let _filters: string = "";
      if (filters && filters.length > 0) _filters = this.filterBuilder(filters);
      let _orderBy: string = "";
      if (gridSorting && gridSorting.length > 0) _orderBy = this.orderByBuilder(gridSorting);
      if (_orderBy == '') _orderBy = '$orderby=Id desc';
      let _oDataParams: string = (_filters != '' ? _filters + "&" : '') + _orderBy;

      if (top !== undefined && skip !== undefined) {
        _oDataParams += `&$top=${top}&$skip=${skip}`;
      }

      if (_filters != '' || _orderBy != '') _oDataParams = '?' + _oDataParams;

      return this.httpClient.get<oDataRes>(`${this.globals.apiUrl}odata/${entity}/getAll${_oDataParams}`);
    }

    return of(new oDataRes);
  }

  exportToExcelByEndpoint(endpoint: string, filters: ActiveFilter[], gridSorting: GridSorting[], defaultOrderBy: string): Observable<any> {
    let _filters: string = "";
    if (filters && filters.length > 0) _filters = this.filterBuilder(filters);
    let _orderBy: string = "";
    if (gridSorting && gridSorting.length > 0) _orderBy = this.orderByBuilder(gridSorting);
    if (_orderBy == '') _orderBy = `$orderby=${defaultOrderBy}`;
    let _oDataParams: string = (_filters != '' ? _filters + "&" : '') + _orderBy;
    if (_filters != '' || _orderBy != '') _oDataParams = '?' + _oDataParams;

    return this.httpClient.get<oDataRes>(`${this.globals.apiUrl}${endpoint}${_oDataParams}`);
  }

  exportEnquiryToExcel(entity: string, filters: ActiveFilter[], gridSorting: GridSorting[], defaultView: string): Observable<any> {
    return this.exportToExcelByEndpoint(`odata/export/${defaultView}`, filters, gridSorting, 'CreationDate desc');
  }

  /***
   * GET ENQUIRY BOOKS
   */
  /*   getEnquiryBooks(filters: ActiveFilter[],gridSorting: GridSorting[], defaultView: string): Observable<oDataRes>{
      if (this.globals.isMock){
        return this.httpClient.get<oDataRes>(withAssetVersion('assets/mock/enquiryBooks.json'));
      } else {
        let _filters: string = "";
        if (filters && filters.length > 0) _filters = this.filterBuilder(filters); 
        let _orderBy:string = "";
        if (gridSorting && gridSorting.length > 0) _orderBy = this.orderByBuilder(gridSorting);
        if (_orderBy == '') _orderBy = '$orderby=LastRevisionDate desc'; 
        let _oDataParams: string = (_filters != '' ? _filters + "&" : '') + _orderBy;
        if (_filters != '' || _orderBy != '') _oDataParams = '?' + _oDataParams;
             
        console.log("[QuoteTool] oDataService oData query parameters: " + _oDataParams);
        return this.httpClient.get<oDataRes>(`${this.globals.apiUrl}odata/Enquiries/${defaultView}${_oDataParams}`);
      }
    } */

  /* FILTER BUILDER FOR ODATA CALL */
  filterBuilder(filters: ActiveFilter[]): string {
    let _ret: string = "$filter=";

    for (var x = 0; x < filters.length; x++) {
      const sanitizedValue = typeof filters[x].value === 'boolean'
        ? filters[x].value
        : this.replaceSpecialCharacters(filters[x].value);

      if (filters[x].operator == 'eq') {
        /* EQUALS */
        _ret = _ret + filters[x].columun! + " eq " + sanitizedValue + "";
      } else if (filters[x].operator == 'contains') {
        /* CONTAINS */
        _ret = _ret + 'contains(tolower(' + filters[x].columun! + "), '" + sanitizedValue.toString().toLowerCase() + "')";
      } else if (filters[x].operator == 'in') {
        const listValues = Array.isArray(sanitizedValue) ? sanitizedValue : [sanitizedValue];
        let _str: string = listValues.join("','"); //.replace(",", "','");
        _ret = _ret + " " + filters[x].columun!.toString() + " in ('" + _str + "')";
      } else if (filters[x].operator == 'num' && filters[x].value) {
        if (filters[x].dateDirection == 'eq') {
          _ret = _ret + filters[x].columun! + " eq " + filters[x].value! + "";
        }
        if (filters[x].dateDirection == 'lt') {
          _ret = _ret + filters[x].columun! + " lt " + filters[x].value! + "";
        }
        if (filters[x].dateDirection == 'gt') {
          _ret = _ret + filters[x].columun! + " gt " + filters[x].value! + "";
        }
        /*  if (filters[x].dateDirection == 'ltgt') {
           _ret = _ret + filters[x].columun! + " eq " + filters[x].value! + ""; 
         } */
      } else {
        /* DATE */
        const column = filters[x].columun!;
        const rangeStart = getDateOnlyRangeStart(filters[x].value);
        const rangeEndExclusive = getDateOnlyRangeEndExclusive(filters[x].value);
        if (rangeStart == null || rangeEndExclusive == null) continue;

        if (filters[x].dateDirection == 'eq') {
          _ret = _ret + `${column} ge ${rangeStart} and ${column} lt ${rangeEndExclusive}`;
        } else {
          // Devo capire se per singolo campo ho uno o due filtri (quindi è un between)
          let _numPerField: number = filters.filter(f => f.columun == filters[x].columun!).length;
          if (filters[x].dateDirection == 'gt') {
            const boundary = _numPerField == 1 ? rangeEndExclusive : rangeStart;
            _ret = _ret + `${column} ge ${boundary}`;
          }

          if (filters[x].dateDirection == 'lt') {
            const boundary = _numPerField == 1 ? rangeStart : rangeEndExclusive;
            _ret = _ret + `${column} lt ${boundary}`;
          }
        }
      }
      _ret = _ret + (filters.length > 1 && x < (filters.length - 1) ? ' and ' : '');
    }

    return _ret;
  }

  /* ODERBY BUILDER FOR ODATA CALL */
  orderByBuilder(gridSorting: GridSorting[]): string {
    let _ret: string = "$orderby=";
    for (var x = 0; x < gridSorting.length; x++) {
      _ret = _ret + gridSorting[x].column! + " " + gridSorting[x].direction!;
      _ret = _ret + (gridSorting.length > 1 && x < (gridSorting.length - 1) ? ',' : '');
    }
    return _ret;
  }

  /**
   * Replace special chars for oData
   */
  replaceSpecialCharacters(attribute: any): any {
    const sanitizeString = (value: string): string => {
      let output = value;
      output = output.replace(/'/g, "''");
      output = output.replace(/%/g, "%25");
      output = output.replace('+', "%2B");
      output = output.replace(/\//g, "%2F");
      output = output.replace(/"?"/g, "%3F");
      output = output.replace(/#/g, "%23");
      output = output.replace(/&/g, "%26");
      return output;
    };

    if (Array.isArray(attribute)) {
      return attribute.map(item => typeof item === 'string' ? sanitizeString(item) : item);
    }

    if (typeof attribute === 'string') {
      return sanitizeString(attribute);
    }

    return attribute;

  }

  /************************* NEW VERSION ***************************/
  getEnquiries(defaultView: string): Observable<oDataRes> {
    let _oDataParams: string = "$orderby=CreationDate desc";
    return this.httpClient.get<oDataRes>(`${this.globals.apiUrl}odata/Enquiries/${defaultView}${_oDataParams}`);
  }

  /**************** GET FILTERS MAPS ****************************/
  getODataFiltersMapping(): Observable<ODataGridFilter[]> {
    return this.httpClient.get<ODataGridFilter[]>(withAssetVersion('assets/mock/oDataGridFilters.json'));
  }
} 
